import { Component, Inject, OnInit, Optional, WritableSignal, inject, signal } from '@angular/core';
import { FulfillmentOrderStatus } from '@vendasta/sales-orders';
import { WorkOrderPersona, statusColorMap } from '@vendasta/work-order';
import { SalesOrderTableCustomComponentDirective } from './sales-order-table-custom.component';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const UNIFIED_TABLES_FEATURE = 'pion_unifying_sales_fulfillment';

@Component({
  selector: 'sales-ui-status-cell',
  styleUrls: ['./fulfillment-cell.component.scss'],
  templateUrl: './fulfillment-cell.component.html',
})
export class FulfillmentCellComponent extends SalesOrderTableCustomComponentDirective implements OnInit {
  stringStatus = '';
  orderID: string;
  badgeColor: string;
  fulfillmentOrderStatus = FulfillmentOrderStatus;
  queryParamsLink: { [key: string]: string };
  hasFulfillment: boolean;
  router: Router = inject(Router);
  private hasAccessToUnifiedTables: WritableSignal<boolean> = signal(false);

  constructor(
    @Inject('PARTNER_ID') readonly partnerId$: Observable<string>,
    @Inject('FULFILLMENT_CELL_LINK_VERSION') readonly fulfillmentCellLinkVersion: boolean,
    @Optional() @Inject(UNIFIED_TABLES_FEATURE) private readonly hasAccessToUnifiedTables$: Observable<boolean>,
  ) {
    super();

    this.hasAccessToUnifiedTables$?.pipe(takeUntilDestroyed())?.subscribe((hasAccessToUnifiedTable) => {
      this.hasAccessToUnifiedTables.set(hasAccessToUnifiedTable);
    });
  }

  ngOnInit(): void {
    this.stringStatus = this.fulfillmentOrderStatus[this.element.fulfillmentOrderStatus];
    this.orderID = this.element.orderId;
    this.queryParamsLink = this.getLinkQueryParams();
    this.hasFulfillment = this.element.hasFulfillment;

    // leave an entry empty if there are no fulfillment orders associated with the sales order
    if (this.stringStatus !== 'FULFILLMENT_STATUS_UNSET') {
      const statusAsNumber: number = this.convertStringStatusToNumber(this.stringStatus);
      this.badgeColor = statusColorMap.get(WorkOrderPersona.CP).get(statusAsNumber);
    }
  }

  convertStringStatusToNumber(fulfillmentOrderStatus: string): number {
    return Object.values(FulfillmentOrderStatus).indexOf(fulfillmentOrderStatus);
  }

  getLinkQueryParams() {
    const queryParams = {
      orderIds: [this.orderID],
    };
    const queryParamString = JSON.stringify(queryParams);
    return { 'order-fufillment-table': queryParamString, tab: 'fulfillment' };
  }

  handleViewItemsClick(): void {
    this.hasAccessToUnifiedTables() ? this.navigateToUnifiedTables() : this.navigateToOrderFulfillmentTable();
  }

  private navigateToUnifiedTables(): void {
    this.router.navigate([], {
      queryParams: this.queryParamsLink,
      queryParamsHandling: 'merge',
    });
  }

  private navigateToOrderFulfillmentTable(): void {
    this.router.navigate(['/order-fulfillment'], {
      queryParams: this.queryParamsLink,
      queryParamsHandling: 'merge',
    });
  }
}
